document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const splash = document.querySelector('[data-brand-splash]');
if (splash) {
  const splashKey = 'stickshiftSplashSeen';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let hasSeenSplash = false;

  try {
    hasSeenSplash = window.sessionStorage.getItem(splashKey) === 'true';
  } catch (error) {
    hasSeenSplash = true;
  }

  if (hasSeenSplash || reduceMotion) {
    splash.remove();
  } else {
    document.documentElement.classList.add('splash-active');

    window.setTimeout(() => {
      splash.classList.add('is-hiding');
      document.documentElement.classList.remove('splash-active');
    }, 1450);

    window.setTimeout(() => {
      splash.remove();
      try {
        window.sessionStorage.setItem(splashKey, 'true');
      } catch (error) {}
    }, 2000);
  }
}

const trapFocus = (container) => {
  const focusable = container.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (focusable.length) focusable[0].focus();
};

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-drawer-open]');
  const closer = event.target.closest('[data-drawer-close]');
  if (opener) {
    const drawer = document.querySelector(opener.dataset.drawerOpen);
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
    trapFocus(drawer);
  }
  if (closer) {
    const drawer = closer.closest('.drawer, .search-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.drawer.is-open, .search-drawer.is-open').forEach((drawer) => drawer.classList.remove('is-open'));
  document.body.classList.remove('drawer-open');
});

const header = document.querySelector('[data-site-header]');
if (header) {
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

document.querySelectorAll('[data-video-placeholder]').forEach((button) => {
  button.addEventListener('click', () => {
    const src = button.dataset.videoSrc;
    if (!src) return;
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.loading = 'lazy';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    button.replaceWith(iframe);
  });
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const slides = Array.from(gallery.querySelectorAll('[data-product-gallery-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
  const previous = gallery.querySelector('[data-product-gallery-prev]');
  const next = gallery.querySelector('[data-product-gallery-next]');

  if (slides.length <= 1) return;

  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

  const pauseMedia = (slide) => {
    slide.querySelectorAll('video').forEach((video) => video.pause());
    slide.querySelectorAll('iframe').forEach((iframe) => {
      const src = iframe.src;
      iframe.src = src;
    });
  };

  const setActiveSlide = (index) => {
    activeIndex = (index + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.hidden = !isActive;
      if (!isActive) pauseMedia(slide);
    });

    thumbs.forEach((thumb, thumbIndex) => {
      const isActive = thumbIndex === activeIndex;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  };

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => setActiveSlide(index));
  });

  previous?.addEventListener('click', () => setActiveSlide(activeIndex - 1));
  next?.addEventListener('click', () => setActiveSlide(activeIndex + 1));

  gallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') setActiveSlide(activeIndex - 1);
    if (event.key === 'ArrowRight') setActiveSlide(activeIndex + 1);
  });
});

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(() => {});
  }
}

customElements.define('product-recommendations', ProductRecommendations);
